export const appBarTranslations = {
  company_details: 'Company details',
  axa_header: 'AXA Company Savings',
};
